import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import '../css/style.css'; // Previously: './WhatToVisit.css';
import Logo from '../assets/logo.svg'; // Import SVG direktno kao komponentu
import ScrollableFilter from '../components/ScrollableFilter'; // Dodaj import za novu komponentu
import ImageSlider from '../components/ImageSlider'; // Import komponente za slajder

const WhatToVisit = () => {
    const { slug } = useParams(); // Dohvati slug iz URL-a
    const [places, setPlaces] = useState([]); // Podaci za atrakcije
    const [categories, setCategories] = useState([]); // Kategorije za filter
    const [filteredPlaces, setFilteredPlaces] = useState([]); // Filterovani rezultati
    const [activeFilter, setActiveFilter] = useState('All'); // Aktivni filter
    const [sliderImages, setSliderImages] = useState([]); // Slike za slajder
    const [coverImage, setCoverImage] = useState('/images/default.jpg'); // Default slika
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Dohvati sve atrakcije vezane za ovaj smeštaj
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/accommodations/${slug}/what-to-visit`);
                const sortedPlaces = response.data.sort((a, b) => a.title.localeCompare(b.title)); // Sortiraj po naslovu
                setPlaces(sortedPlaces);
                setFilteredPlaces(sortedPlaces); // Inicijalno svi podaci

                // Generiši kategorije na osnovu atrakcija
                const uniqueCategories = ['All', ...new Set(sortedPlaces.map(place => place.category_name))];
                setCategories(uniqueCategories);

                // Dohvati slike za slajder i cover image
                const accommodationResponse = await axios.get(
                    `${process.env.REACT_APP_BACKEND_URL}/api/accommodations/${slug}`
                );

                const images = accommodationResponse.data.slider_images
                    ? accommodationResponse.data.slider_images
                        .split(';')
                        .map((img) => `${process.env.REACT_APP_BACKEND_URL}/${img}`)
                    : [];

                if (images.length > 0) {
                    setSliderImages(images); // Ako postoje slike, koristi ih za slajder
                } else if (accommodationResponse.data.cover_image) {
                    // Ako nema slika za slajder, koristi cover_image
                    setCoverImage(`${process.env.REACT_APP_BACKEND_URL}/${accommodationResponse.data.cover_image}`);
                }

                setLoading(false);
            } catch (err) {
                console.error('Error fetching places:', err);
                setError('Failed to load places.');
                setLoading(false);
            }
        };

        fetchData();
    }, [slug]); // Re-fetch podataka kada se slug promeni

    const handleFilterChange = (filter) => {
        setActiveFilter(filter);
        if (filter === 'All') {
            setFilteredPlaces(places); // Prikazuje sve
        } else {
            setFilteredPlaces(places.filter(place => place.category_name === filter));
        }
    };

    if (loading) {
        return (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                fontFamily: 'Montserrat, sans-serif',
                backgroundColor: 'rgba(255, 255, 255, 0.7)', // Transparentna pozadina
            }}>
                <img
                    src={Logo} // Ucitavanje SVG fajla
                    alt="Loading logo"
                    style={{ width: '150px', marginBottom: '20px' }} // Stil za logo
                />
                <p style={{ fontSize: '20px', fontWeight: 'bold', margin: '0' }}>Loading...</p>
            </div>
        );
    }

    if (error) {
        return <p>{error}</p>;
    }

    if (!places.length) {
        return <p>No places to visit for this accommodation.</p>;
    }

    return (
        <div className="what-to-visit-page">
            <div className="header-slider">
                {sliderImages.length > 0 ? (
                    <ImageSlider images={sliderImages} />
                ) : (
                    <div
                        className="header-image"
                        style={{
                            backgroundImage: `url(${coverImage})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            height: '300px',
                        }}
                    />
                )}
            </div>

            <div className="content-boxed">
                <div className="breadcrumb-container">
                    <p className="breadcrumb">
                        <Link to={`/accommodations/${slug}`} className="breadcrumb-link">Home</Link>
                        <span className="breadcrumb-divider"> &gt; </span>
                        <span className="current-page">What to Visit</span>
                    </p>
                </div>

                {/* Filter dugmadi */}
                <ScrollableFilter className="filter-section">
                    {categories.map((category, index) => (
                        <button
                            key={index}
                            className={category === activeFilter ? 'active' : ''}
                            onClick={() => handleFilterChange(category)}
                        >
                            {category}
                        </button>
                    ))}
                </ScrollableFilter>

                {/* Prikazivanje atrakcija */}
                <div className="gallery">
                    {filteredPlaces.map((place, index) => (
                        <Link
                            to={`/accommodations/${slug}/what-to-visit/${place.id}`} // Generiše ispravan URL za navigaciju
                            className="gallery-item"
                            key={index}
                        >
                            <img
                                src={place.image ? `${process.env.REACT_APP_BACKEND_URL}/${place.image}` : '/images/noimage.jpg'}
                                alt={place.title || 'No title available'}
                            />
                            <div className="place-info">
                                <h3>{place.title || 'No title available'}</h3>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default WhatToVisit;
